import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import constant from '../../constant'
import { getStorage } from '../../utils';
import { isATSEnabled } from '../../action/auth';
export default class AsideRightMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Storage: getStorage(constant.keys.userDetails),
            ATS_ENABLED: 0
        }
    }
    componentDidMount() {
        isATSEnabled().then(res => {
            if (res.status) {
                this.setState({ ATS_ENABLED: res.result })

            }
        })
    }


    render() {
        const { Storage, ATS_ENABLED } = this.state;
        return (
            <React.Fragment>
                <div className="nav-side-menu">
                    <i className="fa fa-bars fa-2x toggle-btn" data-toggle="collapse" data-target="#menu-content"></i>
                    <div className="menu-list menu-list-mobile">
                        <ul id="menu-content" className="menu-content collapse out">

                            <li data-toggle="collapse" data-target="#products" className="collapsed active">
                                <a href="#"><i className="la la-briefcase fa-lg"></i> Jobs & Responses <span className="arrow"></span></a>
                            </li>
                            <ul className="sub-menu collapse show" id="products">
                                <Link to={constant.component.PostAJob.url} onClick={() => { sessionStorage.clear() }}><li className="active">Post New Job</li></Link>
                                {/* <Link to={constant.component.PostAFeaturedJob.url} ><li className="active">Post a Featured Job</li></Link> */}
                                {/* <Link to={constant.component.PostAPremiumJob.url} ><li className="active">Post a Premium Job</li></Link> */}
                                <li><a target='_blank' href={constant.component.JobList.url + '?f=ALL&l=10&p=1'}>Manage Jobs & Responses</a></li>
                                {ATS_ENABLED == 1 && <li><a target='_blank' href={constant.component.candidateSearch.url}>Candidate Search</a></li>}
                                {ATS_ENABLED == 1 && <li><a target='_blank' href={constant.component.addCandidate.url}>Add New Candidate</a></li>}
                            </ul>
                            {/* <li data-toggle="collapse" data-target="#campus" className="collapsed active">
                                <a href="#"><i className="la la-graduation-cap fa-lg"></i> Campus Oppurtunities <span className="arrow"></span></a>
                            </li>
                            <ul className="sub-menu collapse show" id="campus">
                                <Link to={constant.component.PostACampusJob.url} ><li className="active">Post Campus Job</li></Link>
                                <Link to={constant.component.PostInternship.url} ><li className="active">Post Internships</li></Link>
                                <li><a target='_blank' href={constant.component.campusJobList.url + '?f=ALL&l=10&p=1'}>Manage Jobs Responses</a></li>
                                <li><a target='_blank' href={constant.component.campusInternshipList.url + '?f=ALL&l=10&p=1'}>Manage Internship Responses</a></li>
                            </ul> */}

                            {/* <li data-toggle="collapse" data-target="#service" className="collapsed active">
                                <a href="#"><i className="la la-users fa-lg"></i> Administration Control Panel <span className="arrow"></span></a>
                            </li>
                            <ul className="sub-menu collapse show" id="service">
                                <li><a href="#">Canditates Management</a></li>
                            </ul> */}


                            <li data-toggle="collapse" data-target="#new" className="collapsed active">
                                <a href="#"><i className="la la-gear fa-lg"></i> Administration <span className="arrow"></span></a>
                            </li>
                            <ul className="sub-menu collapse show" id="new">
                                {Storage.USER_TYPE === 'EMPLOYER' && <Link to={constant.component.EditProfile.url} >  <li className="active">Update Company Profile</li></Link>}
                                {Storage.USER_TYPE === 'EMPLOYER' && <Link to={constant.component.updateKyc.url} ><li className="active">Validate KYC</li></Link>}
                                <Link to={constant.component.RecruiterGuidelines.url}><li className="active">Recruiter Guidelines</li></Link>
                            </ul>

                            {/* <li data-toggle="collapse" data-target="#hiring" className="collapsed active">
                                <a href="#"><i className="la la-file fa-lg"></i> Plan Your Hiring <span className="arrow"></span></a>
                            </li>
                            <ul className="sub-menu collapse show" id="hiring">
                                <Link to={constant.component.eventCalender.url}><li className="active">Create Your Future Plan</li></Link>
                                <Link to={constant.component.futureHiringList.url}><li className="active">Future Hiring List</li></Link>

                            </ul> */}
                            {/* <li data-toggle="collapse" data-target="#report" className="collapsed active">
                                <a href="#"><i className="la la-file-text-o fa-lg"></i> Reports <span className="arrow"></span></a>
                            </li> */}
                            {/* <ul className="sub-menu collapse show" id="report">
                                <li><a href="#">Resume Access Reports</a></li>
                                <li><a href="#">Activity Log</a></li>
                            </ul> */}

                            {/* <li data-toggle="collapse" data-target="#search" className="collapsed active">
                                <a href="#"><i className="la la-search fa-lg"></i> Search Resumes <span className="arrow"></span></a>
                            </li>
                            <ul className="sub-menu collapse show" id="search">
                                <li><a href="#">Advanced Search</a></li>
                            </ul> */}
                            {Storage.USER_TYPE === 'EMPLOYER' && <><li className="collapsed active">
                                <a href={constant.component.UserCreate.url}>
                                    <i className="la la-users fa-lg"></i> Manage Subusers
                                </a>
                            </li>
                                {/* <li className="collapsed active">
                                    <a href={constant.component.Outplacement.url}>
                                        <i className="la la-user fa-lg"></i> Outplacement
                                    </a>
                                </li> */}
                            </>
                            }
                            {/* <li className="collapsed active">
                                <a href={constant.component.Rewards.url}>
                                    <i className="fa fa-ticket"></i>Rewards<sup className='new-sup'>New</sup>
                                </a>
                            </li> */}
                            {Storage.USER_TYPE === 'EMPLOYER' && <li className="collapsed active">
                                <a href={constant.component.TransactionHistory.url}>
                                    <i className="la la-money fa-lg"></i>Transaction History
                                </a>
                            </li>}
                            <li className="collapsed active">
                                <a href={constant.component.viewProfile.url}>
                                    <i className="la la-user fa-lg"></i> View Profile
                                </a>
                            </li>
                            <li className="collapsed active">
                                <a href={constant.component.logout.url}>
                                    <i className="la la-power-off fa-lg"></i> Logout
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </React.Fragment >
        )
    }
}
